import { render } from "./LinksDetails.vue?vue&type=template&id=0d035815"
import script from "./LinksDetails.vue?vue&type=script&lang=js"
export * from "./LinksDetails.vue?vue&type=script&lang=js"

import "./LinksDetails.vue?vue&type=style&index=0&id=0d035815&lang=css"

import exportComponent from "/Users/andreavadacchino/Desktop/pADV/untitled/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__